import { useEffect } from 'react';
import { useAppSelector } from 'app/hooks';
import { selectUser } from 'features/auth';
import { selectJobSeeker } from 'features/job-seeker-auth';

const usePendo = (): void => {
  const user = useAppSelector(selectUser);
  const jobSeeker = useAppSelector(selectJobSeeker);

  useEffect(() => {
    if (!window.pendo) return;

    if (jobSeeker) {
      window.pendo.initialize({
        visitor: {
          id: jobSeeker.id,
          email: jobSeeker.email,
          full_name: jobSeeker.name,
        },
        account: {
          id: jobSeeker.id,
          accountName: jobSeeker.name,
        },
      });
      return;
    }

    if (user) {
      window.pendo.initialize({
        visitor: {
          id: user.id,
          email: user.email,
          full_name: user.name,
        },
        account: {
          id: user.id,
          accountName: user.name,
        },
      });
    }
  }, [user, jobSeeker]);
};

export default usePendo;
